import { Link } from 'react-router-dom';
import { completedComics } from '@/mocks/comics';

export default function CompletedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              完结精品
            </h2>
            <p className="text-foreground-500 text-sm">一次看过瘾，口碑完结漫画</p>
          </div>
          <Link
            to="/category?filter=completed"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {completedComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-accent-300 transition-all duration-200 hover:-translate-y-1"
            >
              {/* Completed Badge */}
              <div className="absolute top-3 right-3 z-10 px-2.5 py-1 rounded-full bg-accent-500 text-white text-[10px] font-semibold">
                已完结
              </div>

              {/* Cover */}
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 奇妙漫画完结精品`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <p className="text-white/90 text-sm font-heading font-semibold line-clamp-1">{comic.title}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="flex items-center gap-1 text-xs text-amber-400">
                      <i className="ri-star-fill text-[10px]"></i>
                      {comic.rating}
                    </span>
                    <span className="text-xs text-white/60">{comic.chapters.length}话</span>
                    <span className="text-xs text-white/60">{(comic.views / 10000).toFixed(0)}万阅读</span>
                  </div>
                </div>
              </div>

              {/* Info */}
              <div className="p-3 md:p-4">
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{comic.description}</p>
                <div className="flex flex-wrap gap-1 mt-2">
                  {comic.tags.slice(0, 3).map((tag) => (
                    <span key={tag} className="text-[10px] px-1.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category?filter=completed"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}